import React from 'react'
import { Input } from 'reactstrap'


export default class CoreSimpleSelect extends React.Component {
	render() {
		const mappedOptions = this.props.options.map(item =>
			<option
				key={item[this.props.itemKeyValue]}
				value={item[this.props.itemKeyValue]}
			>{item[this.props.itemKeyLabel]}</option>
		)


		return (
			<Input
				type="select"
				onChange={this.props.onChange}
				name={this.props.name}
				value={this.props.value}
				style={{ width: '100%' }}
			>
				{
					this.props.labelForBlank !== '' &&

					<option value="">
						{this.props.labelForBlank}
					</option>
				}
				{mappedOptions}
			</Input>
		)
	}
}

CoreSimpleSelect.defaultProps = {
	labelForBlank: ''
}



// WEBPACK FOOTER //
// ./src/modules/_core/simpleSelect.jsx